import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { isOpen?: boolean, height: number, width: number }) => ({
  transform: props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.4s',
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type ArrowDownIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
  isOpen?: boolean,
}>;

export const ArrowDownIcon: React.FC<ArrowDownIconProps> = ({ width = 12, height = 8, color = colors.primary, isOpen, ...props }) => (
  <IconSpan {...props} isOpen={isOpen} height={height} width={width}>
    <svg width={width} height={height} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 7.4L0 1.4L1.4 0L6 4.6L10.6 0L12 1.4L6 7.4Z" fill={color} />
    </svg>
  </IconSpan>
);
